import { useOrganizationCloudRenderingPolicies } from "../../hooks";
import { BrowserStreamingProtocol } from "../../hooks/types";
import { useUserPreferencesQuery } from "../../hooks/useUserPreferences";
import { evaluateUserPreferenceAgainstPolicy } from "../../utils/policy-evaluation";

export function useBrowserStreamingProtocolSettingQuery() {
  const { data: policies, isSuccess } = useOrganizationCloudRenderingPolicies();
  return useUserPreferencesQuery({
    enabled: isSuccess,
    select: (data) => {
      if (!data || !policies) {
        return BrowserStreamingProtocol.WebRTC;
      }

      return evaluateUserPreferenceAgainstPolicy({
        userPreference: data.browserStreamingProtocol,
        policy: policies.streamingGatewayPolicy,
        enforcedValue: BrowserStreamingProtocol.DCV,
        disallowedValue: BrowserStreamingProtocol.WebRTC,
        defaultValue: BrowserStreamingProtocol.WebRTC,
      });
    },
  });
}
